import { LocationType } from '~/client/graph'
import FieldIds from '~/client/src/shared/enums/DeliveryFieldIds'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import {
  iconNameFromKind,
  readStoredKind,
} from '~/client/src/shared/resources/domain/locationKind'
import ILocationAttributeDto from '~/client/src/shared/types/ILocationAttributeDto'

import LocationAttributeBase from './LocationAttributeBase'

/**
 * A place none of the twelve kind models holds: its root kind is one the project added
 * itself, or it has no kind at all (STX1-597).
 *
 * Typed as the collapsed LocationType.Location on purpose. getDto re-asserts the model's
 * kind into data, and a plain Location's kind is read from data alone, so saving one writes
 * back exactly the kind it was loaded with - a custom kind survives, and a location with
 * no kind is not handed one.
 */
export default class OtherLocation extends LocationAttributeBase<OtherLocation> {
  public static fromDto(dto: ILocationAttributeDto) {
    return LocationAttributeBase.factory(
      OtherLocation,
      dto,
      // A kind can name a library pictogram; the model field holds it as IconSelector does.
      (iconNameFromKind(readStoredKind(dto.data)) as MapViewLocationIcon) ??
        MapViewLocationIcon.Logistics,
    )
  }

  public type = LocationType.Location
  protected relatedFieldId = FieldIds.LOCATION
  protected model = OtherLocation
}
